import { Chain, useChainContext } from '@popup/multichain/multichain.context';
import React from 'react';
export const EvmAppComponent = () => {
    const { setChain } = useChainContext();
    return (React.createElement("div", null,
        React.createElement("button", { onClick: () => setChain(Chain.STEEM) }, "switch to steem")));
};
